<template>
  <div>
    <a href @click.prevent="triggerInput" class="tw-flex tw-justify-center">
      <img :src="value" v-if="value" class="tw-max-w-tw-mx-auto" />
      <div class="tw-flex tw-flex-col tw-items-center tw-text-gray-600" v-else>
        <Icon class="tw-mx-auto" icon="arrow-alt-circle-up" size="5x" />
        <p class="tw-text-center">Upload logo</p>
      </div>
    </a>
    <div v-if="logoPicker" class="d-flex justify-center mt-2">
      <v-icon
        style="pointer-events: auto"
        slot="append-outer"
        @click="$emit('deleteLogo')"
      >
        mdi-delete
      </v-icon>
    </div>
    <input type="file" accept="image/*" ref="fileInput" style="display: none" @change="readLogo" />
    <Modal
      :closeOnCurtainClick="true"
      :showCloseButton="true"
      ref="fileSizeModal"
      :fileSize="fileSize"
    >
      <template>
        <div class="tw-text-center">
          <Icon icon="exclamation-circle" size="5x" />
          <h2 class="tw-mt-3">
            Selected file size {{ parseInt(fileSize / 1024) }}Kb is too large.
          </h2>

          <p>
            Maximum image size allowed is 500kb.
          </p>

        </div>
      </template>
      <template #buttons>
        <v-btn color="secondary" @click="closeModal()">Close</v-btn>
      </template>
    </Modal>
  </div>

</template>

<script>
import Icon from '@/common/icon';
import Modal from '@/common/components/Modal.vue';

export default {
  props: {
    value: {
      required: true,
    },
    isEditing: {
      type: Boolean,
      required: false,
      default: true,
    },
    logoPicker: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      fileSize: 0,
    };
  },
  methods: {
    triggerInput() {
      if (this.isEditing) {
        this.$refs.fileInput.click();
      }
    },
    readLogo(evt) {
      const input = evt.target;
      if (input.files && input.files[0]) {
        this.fileSize = input.files[0].size;
        const allowedExtensions = ['jpg', 'jpeg', 'gif', 'png'];
        const extension = input.files[0].name.split('.').pop().toLowerCase();
        if (allowedExtensions.indexOf(extension) === -1) {
          this.$toasted.error('Please make sure your image is in one of the following allowed formats: .jpg, .png, .gif');
        } else if (Math.round(input.files[0].size / 1024) > 500) {
          this.$refs.fileSizeModal.show();
          input.value = '';
        } else {
          const reader = new FileReader();
          reader.onload = (e) => {
            this.$emit('input', e.target.result);
          };
          reader.readAsDataURL(input.files[0]);
        }
      }
    },
    closeModal() {
      this.$refs.fileSizeModal.hide();
    },
  },
  components: {
    Icon,
    Modal,
  },
};
</script>
